import type { RouteRecordRaw } from 'vue-router';

export const infoProductRoutes: Array<RouteRecordRaw> = [
  {
    path: '/info/product',
    name: 'infoProduct',
    redirect: '/info/product/list',
    component: () => import('pages/info/product/McProduct.vue'),
    meta: {
      title: 'Products',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'infoProductList',
        component: () => import('pages/info/product/ProductList.vue'),
        meta: {
          title: 'Products List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'infoProductDetail',
        component: () => import('pages/info/product/ProductDetail.vue'),
        meta: {
          title: 'Product Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'infoProductNew',
        component: () => import('pages/info/product/ProductNew.vue'),
        meta: {
          title: 'New Product',
          requiresAuth: true,
        },
      },
      {
        path: 'view/:itemId?',
        name: 'infoProductView',
        component: () => import('pages/info/product/ProductView.vue'),
        meta: {
          title: 'Product Details (View only)',
          requiresAuth: true,
        },
      },
      {
        path: 'explorer',
        name: 'infoProductExplorer',
        component: () => import('pages/info/product/ProductExplorer.vue'),
        meta: {
          title: 'Products Explorer',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/info/product/category',
    name: 'infoProductCategory',
    redirect: '/info/product/category/list',
    component: () => import('pages/info/productCategory/ProductCategory.vue'),
    meta: {
      title: 'Product Categories',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list/:productId?/:groupId?/:appId?',
        name: 'infoProductCategoryList',
        component: () => import('pages/info/productCategory/ProductCategoryList.vue'),
        meta: {
          title: 'Product Categories List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?/:productId?/:groupId?/:appId?',
        name: 'infoProductCategoryDetail',
        component: () => import('pages/info/productCategory/ProductCategoryDetail.vue'),
        meta: {
          title: 'Product Category Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new/:productId?/:groupId?/:appId?',
        name: 'infoProductCategoryNew',
        component: () => import('pages/info/productCategory/ProductCategoryNew.vue'),
        meta: {
          title: 'New Product Category',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/info/feature/category',
    name: 'infoFeatureCategory',
    redirect: '/info/feature/category/list',
    component: () => import('pages/info/featureCategory/FeatureCategory.vue'),
    meta: {
      title: 'Feature Categories',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'infoFeatureCategoryList',
        component: () => import('pages/info/featureCategory/FeatureCategoryList.vue'),
        meta: {
          title: 'Feature Categories List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'infoFeatureCategoryDetail',
        component: () => import('pages/info/featureCategory/FeatureCategoryDetail.vue'),
        meta: {
          title: 'FeatureCategory Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'infoFeatureCategoryNew',
        component: () => import('pages/info/featureCategory/FeatureCategoryNew.vue'),
        meta: {
          title: 'New FeatureCategory',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/info/feature/item',
    name: 'infoFeatureItem',
    redirect: '/info/feature/item/list',
    component: () => import('pages/info/featureItem/FeatureItem.vue'),
    meta: {
      title: 'Feature Items',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'infoFeatureItemList',
        component: () => import('pages/info/featureItem/FeatureItemList.vue'),
        meta: {
          title: 'FeatureItems List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'infoFeatureItemDetail',
        component: () => import('pages/info/featureItem/FeatureItemDetail.vue'),
        meta: {
          title: 'FeatureItem Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'infoFeatureItemNew',
        component: () => import('pages/info/featureItem/FeatureItemNew.vue'),
        meta: {
          title: 'New FeatureItem',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/info/feature',
    name: 'infoFeature',
    redirect: '/info/feature/list',
    component: () => import('pages/info/feature/McFeature.vue'),
    meta: {
      title: 'Features',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list/:productId?/:groupId?/:categoryId?/:appId?',
        name: 'infoFeatureList',
        component: () => import('pages/info/feature/FeatureList.vue'),
        meta: {
          title: 'Features List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?/:productId?/:groupId?/:categoryId?/:appId?',
        name: 'infoFeatureDetail',
        component: () => import('pages/info/feature/FeatureDetail.vue'),
        meta: {
          title: 'Feature Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new/:productId?/:groupId?/:categoryId?/:appId?',
        name: 'infoFeatureNew',
        component: () => import('pages/info/feature/FeatureNew.vue'),
        meta: {
          title: 'New Feature',
          requiresAuth: true,
        },
      },
    ],
  },
];
